/**
 * Форматирует строку, содержащую число с юнитами,
 * добавляя пробелы между каждыми тремя цифрами и округляя число.
 * Примеры:
 * "2759 H" -> "2 759 H"
 * "$302" -> "$302"
 * "1234567.89" -> "1 234 567"
 * "1000000.123" -> "1 000 000"
 * "123.456" -> "123"
 */
import React from 'react'
export const formatNumber = (input: string | number | React.ReactNode): string | React.ReactNode => {
  if (input === undefined || input === null) {
    return input
  }
  if (React.isValidElement(input)) {
    return input
  }

  if (typeof input === 'string') {
    if (input.includes('null')) {
      return ''
    }
  }
  const strInput = input!.toString()

  const match = strInput.match(/^(\D*)(\d+(?:\.\d+)?)(\D*)$/)

  if (!match) {
    return strInput
  }

  const [, prefix, numberPart, suffix] = match

  const formattedNumber = Math.floor(parseFloat(numberPart))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  return `${prefix}${formattedNumber}${suffix}`
}
